import { autoinject, bindable, BindingEngine, Disposable } from "aurelia-framework";
import { debounce } from "lodash";

@autoinject
export class MatchHeightCustomAttribute {
	@bindable({ primaryProperty: true }) selector: string;

	private matchHeightSubscriber: Disposable;
	private selectedElement: Element;
	private onResize = debounce(this.syncHeight.bind(this), 200);

	constructor(private el: Element, private be: BindingEngine) {
	}

	syncHeight(): any {
		(<HTMLElement>this.el).style.height = `${this.selectedElement.clientHeight}px`;
	}

	attached() {
		this.selectedElement = document.querySelector(this.selector);
		this.syncHeight();
		this.matchHeightSubscriber = this.be.propertyObserver(this.selectedElement, 'clientHeight').subscribe(this.onResize);
		window.addEventListener('resize', this.onResize, true);
	}

	detached() {
		this.matchHeightSubscriber.dispose();
		window.removeEventListener('resize', this.onResize, true);
	}
}
